import { createContext } from "react";
import type { FuseAuthProviderState } from "@fuse/core/FuseAuthProvider/types/FuseAuthTypes";
import type { User } from "@auth/user";
import type {
	ConcluirEntrarUnificadoOptions,
	EntrarUnificadoOptions,
	ResultadoEntrarUnificado,
	CredenciaisEntrarJwt,
	PayloadConcluirEntrarDoisFatoresJwt,
	ResultadoEntrarJwt,
} from "./tiposAutenticacaoJwt";

// ------------------------------- CONSTANTS -------------------------------
const ContextoAutenticacaoJwt = createContext<TipoContextoAutenticacaoJwt | undefined>(undefined);

// --------------------------------- TYPES ---------------------------------
export type TipoContextoAutenticacaoJwt = FuseAuthProviderState<User> & {
	entrar?: (credentials: CredenciaisEntrarJwt) => Promise<ResultadoEntrarJwt | null>;
	concluirEntrarDoisFatores?: (payload: PayloadConcluirEntrarDoisFatoresJwt) => void;
	entrarUnificado?: (options: Readonly<EntrarUnificadoOptions>) => Promise<ResultadoEntrarUnificado | null>;
	concluirEntrarUnificado?: (options: Readonly<ConcluirEntrarUnificadoOptions>) => boolean;
	sair?: () => void;
};

export default ContextoAutenticacaoJwt;
